import clsx from 'clsx'
import { type PropsWithChildren } from 'react'

type Props = {
  footer?: React.ReactNode
  raw?: boolean
  className?: string
  style?: React.CSSProperties
}

export default function Card ({ footer, raw, children, className = '', style = {} }: PropsWithChildren<Props>) {
  return (
    <div className={clsx('flex flex-col border border-gray-200 rounded-2xl shadow bg-white overflow-hidden', className)} style={style}>
      <div className={clsx('flex flex-col', {
        'p-6': !raw,
        'p-0': raw,
      })}
      >
        {children}
      </div>
      {footer && (
        <div className={clsx('flex flex-col bg-gray-50 border-t border-gray-200 body-sm', {
          'p-6': !raw,
          'p-0': raw,
        })}
        >
          {footer}
        </div>
      )}
    </div>
  )
}
